import { SeuEnvironment } from '@seu-types';

export const SEU_ENVIRONMENT: SeuEnvironment = {
  production: true,
  env: 'dev',
  apiUrl: 'https://api.dev.processdesigner.scheuch.com',
  msal: {
    clientId: 'c5af791b-40d5-4beb-adf7-65e67061ef5a',
    authority:
      'https://login.microsoftonline.com/a2fcf037-4226-400e-8442-294f22277f3b',
    redirectUrl: {
      cdnUrl: 'https://dev.processdesigner.scheuch.com/',
      azureUrl: 'https://scheuchpddevstoreweb.z6.web.core.windows.net/',
    },
  },
  isEnvSwitchAllowed: true,
  mock: false,
  sentryEnabled: false,
  isCanvasDevToolsEnabled: false,
};
